var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnalystNote = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.294 5.823a3.87 3.87 0 0 1 3.867-3.865 3.87 3.87 0 0 1 3.866 3.865 3.87 3.87 0 0 1-3.866 3.866 3.87 3.87 0 0 1-3.867-3.866m3.683-2.7a.37.37 0 0 0-.37.37v2.725c0 .205.166.371.37.371h.575a.37.37 0 0 0 .371-.37V3.493a.37.37 0 0 0-.37-.371zm-.41 4.704a.697.697 0 1 0 1.395 0 .697.697 0 0 0-1.394 0m-.354 2.81v9.032H5.329V5.353h7.948c.057-.593.22-1.156.47-1.668H4.865c-.664 0-1.205.541-1.205 1.205v15.243c0 .665.54 1.205 1.205 1.205h12.81c.665 0 1.205-.54 1.205-1.205v-9.456a4.9 4.9 0 0 1-1.668-.04m-9.55 4.72a.834.834 0 0 0 0 1.668h7.215a.834.834 0 0 0 0-1.668zm0-3.693h7.216a.834.834 0 0 1 0 1.669H7.664a.835.835 0 0 1 0-1.669m6.03-3.667h-6.03a.834.834 0 0 0 0 1.67h7.216a1 1 0 0 0 .125-.01 5 5 0 0 1-1.31-1.66",
    clipRule: "evenodd"
  })));
};
export default SvgAnalystNote;